import Icon from './Icon.tsx';
import { ComposedIconProps } from './Icon.tsx';
import url from '@assets/images/duplicate.svg';

const DuplicateIcon = ({ icon = url, ...rest }: ComposedIconProps) => {
  return <Icon icon={icon} {...rest} />;
};

export default DuplicateIcon;
